import React, {useEffect, useState, useRef, Fragment} from 'react';
import ReactDOM from 'react-dom';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import TextField from '@material-ui/core/TextField';
import Select from '../../../../components/Select';
import Filter from '../../../../components/Filter';
import {Wizard, Explanation_text} from '../../../../components'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { Form, Field } from 'react-final-form';
import Iframes from './Iframes';
import Data from './Data';
import axios from 'axios';
import {connect} from 'react-redux';



function List(props) {
    let iframeSwitch=useRef();
    let setExtraUrl=useRef();
    let setIframeData=useRef();
    let initSalesCoach=useRef();
    const[refresh, setRefresh]=useState(0);
    const[bigWebsite, setBigWebsite]=useState(false);

    console.log('REFRESH VIEWWWW');


    function category(cat){
      initialValues.current=undefined;
      setDataIndex(dataIndex+1);
      setUrl(undefined);
    }


    useEffect(()=>{
      props.setNavigationWidth((bigWebsite==true)?'34vw':'67vw');
      props.setViewMode(true);
      return ()=>{
        props.setNavigationWidth('100vw');
        props.setViewMode(false);
      }
    },[]);


    return(
          <Fragment>
          <Grid container style={{width:'100vw', height:'100vh'}}>
            <Grid id='pv_wiz_2' item xs={(bigWebsite==true)?12:0} sm={(bigWebsite==true)?12:4} md={(bigWebsite==true)?8:4} style={{position:'relative', height:'100%'}}><Iframes {...props} bigWebsite={bigWebsite} setBigWebsite={setBigWebsite} setFunctions={(iframe, extraUrl, iframeData, salesCoach)=>{iframeSwitch.current=iframe; setExtraUrl.current=extraUrl; setIframeData.current=iframeData; initSalesCoach.current=salesCoach; setRefresh(refresh+1);}}/></Grid>
            <Grid item xs={(bigWebsite==true)?0:12} sm={(bigWebsite==true)?0:8} md={(bigWebsite==true)?4:8} style={{width:'100%', height:'100%'}}>{(refresh==0)?null:<Data {...props} bigWebsite={bigWebsite} setBigWebsite={setBigWebsite} setExtraUrl={setExtraUrl.current} setIframeData={setIframeData.current} setIframeIndex={iframeSwitch.current} initSalesCoach={initSalesCoach.current}/>}</Grid>
          </Grid>
          <Wizard type='prospect_view_wizard' wizard_steps={[
            { key: 'pv_wiz_1', title:<Explanation_text text='pv_wizard_first_title'/>, content:<Explanation_text variant='caption' text='pv_wizard_first_content'/>, anchorOrigin:{vertical: 'bottom', horizontal: 'right'}, transformOrigin:{vertical: 'top', horizontal: 'center'}},
            { key: 'pv_wiz_2', title: <Explanation_text text='pv_wizard_second_title'/>, content:<Explanation_text variant='caption' text='pv_wizard_second_content'/>, anchorOrigin:{vertical: 'center', horizontal: 'right'}, transformOrigin:{vertical: 'center', horizontal: 'left'}},
            { key: 'pv_wiz_3', title:<Explanation_text text='pv_wizard_third_title'/>, content:<Explanation_text variant='caption' text='pv_wizard_third_content'/>, anchorOrigin:{vertical: 'top', horizontal: 'center'}, transformOrigin:{vertical: 'bottom', horizontal: 'center'}},
            { key: 'pv_wiz_4', title:<Explanation_text text='pv_wizard_fourth_title'/>, content:<Explanation_text variant='caption' text='pv_wizard_fourth_content'/>, anchorOrigin:{vertical: 'center', horizontal: 'right'}, transformOrigin:{vertical: 'center', horizontal: 'left'}},
            { key: 'pv_wiz_5', title:<Explanation_text text='pv_wizard_fifth_title'/>, content:<Explanation_text variant='caption' text='pv_wizard_fifth_content'/>, anchorOrigin:{vertical: 'top', horizontal: 'left'}, transformOrigin:{vertical: 'top', horizontal: 'right'}}
          ]}/>
        </Fragment>
    );
}


export default connect(ss, dd)(List);



function ss(state){
  return{
    current_list:state.companies.current_list,
    current_list_refresh:state.companies.current_list.refresh
  }
}

function dd(dispatch){
  return{
    setViewMode:(v)=>{dispatch({type:'SET_VIEW_MODE', view_mode:v});}
  }
}
